<template>
  <div class="max-w-md w-full mx-auto pt-16 pb-12">
    <div>
      <h2 class="text-3xl font-bold text-yank leading-none">
        Sign In
      </h2>
      <p class="text-sm font-medium mt-3">
        New User? <inertia-link :href="$route('register.show')" class="text-aquamarine hover:underline">Create a Free Account</inertia-link>
      </p>
    </div>

    <template v-if="social_auth">
      <div class="social-logins space-y-6 mt-18">
        <a :href="$route('socialite.url', 'google')" class="rounded-xl block w-full shadow-card h-16 flex items-center justify-center relative focus:outline-none focus:ring focus:ring-aquamarine focus:ring-offset-2 hover:bg-platinumMild">
          <span class="font-medium">Sign in with Google</span>
          <div class="absolute inset-y-0 flex items-center left-0 ml-6 lg:ml-12">
            <GoogleIcon class="h-6" />
          </div>
        </a>

        <a :href="$route('socialite.url', 'facebook')" class="rounded-xl block w-full shadow-card h-16 flex items-center justify-center relative focus:outline-none focus:ring focus:ring-aquamarine focus:ring-offset-2 hover:bg-platinumMild">
          <span class="font-medium">Sign in with Facebook</span>
          <div class="absolute inset-y-0 flex items-center left-0 ml-6 lg:ml-12">
            <FacebookIcon class="h-6" />
          </div>
        </a>

        <div v-if="errors.socialite" class="p-4 bg-red-50 shadow-md rounded-xl">
          <p class="text-sm text-red-600">{{ errors.socialite }}</p>
        </div>
      </div>

      <div class="relative mt-6">
        <div class="absolute inset-0 flex items-center">
          <div class="w-full border-t border-payneGringo"></div>
        </div>
        <div class="relative flex justify-center text-sm">
          <span class="px-2 bg-white text-payneHot text-sm font-medium">
            Or continue with
          </span>
        </div>
      </div>
    </template>

    <div :class="social_auth ? 'mt-6' : 'mt-20'">
      <form @submit.prevent="login" method="post">
        <div>
          <label for="email" class="block text-gray-500 font-medium text-sm">
            Email
          </label>
          <div class="mt-1 shadow-sm rounded-xl">
            <input type="email" name="email" id="email" v-model="form.email" class="form-input" required>
          </div>
          <div v-if="errors.email" class="text-sm text-red-600 mt-1">
            {{ errors.email }}
          </div>
        </div>

        <div class="mt-6">
          <label for="password" class="block text-gray-500 font-medium text-sm">
            Password
          </label>
          <div class="mt-1 shadow-sm rounded-xl">
            <input type="password" name="password" id="password" v-model="form.password" class="h-13 px-4 text-sm text-gray-600 border border-payne rounded-xl w-full focus:border-yank transition-colors focus:outline-none" required autocomplete="false">
          </div>
        </div>

        <div class="mt-6">
          <button type="submit" class="h-16 w-full text-white text-sm font-semibold rounded-xl shadow-sm bg-aquamarine hover:opacity-90 transition focus:outline-none focus:ring-2 focus:ring-aquamarine focus:ring-offset-2 disabled:opacity-60" :disabled="working">
            <span v-if="! working">Sign In</span>
            <span v-else>Signing In...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AuthLayout from '@/layout/auth-layout'
import GoogleIcon from '@/components/svg/GoogleIcon'
import FacebookIcon from '@/components/svg/FacebookIcon'

export default {
  name: 'Login',

  props: {
    social_auth: Boolean,
    errors: Object,
  },

  layout: AuthLayout,

  components: {
    GoogleIcon, FacebookIcon
  },

  metaInfo: {
    title: 'Sign In',
  },

  remember: ['form'],

  data() {
    return {
      working: false,
      form: {
        email: null,
        password: null,
      }
    }
  },

  methods: {
    login() {
      this.working = true
      this.$inertia.post(this.$route('login.attempt'), this.form, {
        onFinish: () => this.working = false
      })
    }
  },
}
</script>

<style scoped>
  .form-input {
    @apply h-13 px-4 text-sm text-gray-600 border border-payneGringo rounded-xl w-full focus:border-yank transition-colors focus:outline-none;
  }
</style>
